import { useState } from 'react';
import { auth, db } from '../firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

export default function LoginModal({ onClose }) {
  const [mode, setMode] = useState('login'); // 'login' | 'signup' | 'reset'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    setError('');
    setMessage('');

    if (mode === 'reset') {
      if (!email.trim()) { setError('이메일을 입력해주세요.'); return; }
      try {
        await sendPasswordResetEmail(auth, email);
        setMessage('비밀번호 재설정 이메일을 보냈어요. 이메일을 확인해주세요!');
      } catch (e) {
        setError('이메일을 확인해주세요.');
      }
      return;
    }

    if (mode === 'signup') {
      if (!displayName.trim()) { setError('대화명을 입력해주세요.'); return; }
      if (password.length < 6) { setError('비밀번호는 6자 이상이어야 해요.'); return; }
      if (password !== passwordConfirm) { setError('비밀번호가 일치하지 않아요.'); return; }
      try {
        const cred = await createUserWithEmailAndPassword(auth, email, password);
        await setDoc(doc(db, 'users', cred.user.uid), {
          email: cred.user.email,
          displayName: displayName.trim(),
          role: 'business_pro',
          createdAt: serverTimestamp(),
        });
        onClose();
      } catch (e) {
        setError('이미 사용 중인 이메일이에요.');
      }
      return;
    }

    // 로그인
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onClose();
    } catch (e) {
      setError('이메일 또는 비밀번호를 확인해주세요.');
    }
  };

  const titles = { login: '로그인', signup: '회원가입', reset: '비밀번호 찾기' };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: 'white', borderRadius: 16, padding: 24, width: 300,
        display: 'flex', flexDirection: 'column', gap: 12,
      }}>
        <h2 style={{ margin: 0, fontSize: 18 }}>{titles[mode]}</h2>

        <input
          type="email" placeholder="이메일"
          value={email} onChange={e => setEmail(e.target.value)}
          style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 16 }}
        />

        {mode !== 'reset' && (
          <input
            type="password" placeholder="비밀번호 (6자 이상)"
            value={password} onChange={e => setPassword(e.target.value)}
            style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 16 }}
          />
        )}

        {mode === 'signup' && (
          <>
            <input
              type="password" placeholder="비밀번호 확인"
              value={passwordConfirm} onChange={e => setPasswordConfirm(e.target.value)}
              style={{
                padding: '10px 12px', borderRadius: 8, fontSize: 16,
                border: `1px solid ${passwordConfirm && password !== passwordConfirm ? '#e74c3c' : '#ddd'}`,
              }}
            />
            {passwordConfirm && password !== passwordConfirm && (
              <p style={{ color: '#e74c3c', fontSize: 11, margin: '-8px 0 0' }}>비밀번호가 일치하지 않아요</p>
            )}
            <input
              placeholder="대화명 (지도에 표시될 이름)"
              value={displayName} onChange={e => setDisplayName(e.target.value)}
              style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 16 }}
            />
          </>
        )}

        {error && <p style={{ color: 'red', fontSize: 12, margin: 0 }}>{error}</p>}
        {message && <p style={{ color: 'green', fontSize: 12, margin: 0 }}>{message}</p>}

        <button type="button" onClick={handleSubmit} style={{
          padding: '10px 0', borderRadius: 8, border: 'none',
          background: '#333', color: 'white', fontSize: 14, cursor: 'pointer',
        }}>
          {titles[mode]}
        </button>

        {mode === 'login' && (
          <>
            <button type="button" onClick={() => { setMode('signup'); setError(''); setMessage(''); }} style={{
              padding: '8px 0', borderRadius: 8, border: '1px solid #ddd',
              background: 'white', fontSize: 13, cursor: 'pointer',
            }}>
              회원가입
            </button>
            <button type="button" onClick={() => { setMode('reset'); setError(''); setMessage(''); }} style={{
              padding: '8px 0', borderRadius: 8, border: 'none',
              background: 'none', fontSize: 13, color: '#666', cursor: 'pointer',
            }}>
              비밀번호를 잊으셨나요?
            </button>
          </>
        )}

        {mode !== 'login' && (
          <button type="button" onClick={() => { setMode('login'); setError(''); setMessage(''); }} style={{
            padding: '8px 0', borderRadius: 8, border: '1px solid #ddd',
            background: 'white', fontSize: 13, cursor: 'pointer',
          }}>
            로그인으로 돌아가기
          </button>
        )}

        <button type="button" onClick={onClose} style={{
          padding: '8px 0', borderRadius: 8, border: 'none',
          background: 'none', fontSize: 13, color: '#999', cursor: 'pointer',
        }}>
          닫기
        </button>
      </div>
    </div>
  );
}